import React from 'react';
import { h } from '@debbie/cortex/dist/index.js';
import * as users from '@debbie/cortex/dist/users/index.js';
import Preview from '../UserPreview.js';
const UserPreview = (props) => {
    const preview = users.useUserById(props.id);
    return h.hasData(preview) ? (React.createElement("span", { style: { marginRight: '-5px' } },
        React.createElement(Preview, { user: preview.data }))) : null;
};
export default UserPreview;
//# sourceMappingURL=UserPreview.js.map